<template>
    <label class="c-radio">
        <span
            class="c-checkbox--input"
            :class="{'is-checked': checked}"
        >
            <span class="c-checkbox--inner"></span>
            <input
                class="c-checkbox--original"
                type="checkbox"
                :checked="checked"
                :name="name"
                @change="change"
            >
        </span>
        <slot></slot>
    </label>
</template>

<script>
/**
 * @file
 * @author
 */

export default {
    props: {
        trueValue: {
            type: [String, Number, Boolean],
            default: true
        },
        falseValue: {
            type: [String, Number, Boolean],
            default: false
        },
        name: {
            type: String
        }
    },
    data() {
        return {
            checked: false,
            currentValue: this.value
        };
    },
    methods: {
        change(event) {
            const checked = event.target.checked;
            this.checked = checked;
            const value = checked ? this.trueValue : this.falseValue;
            this.$emit('input', value);
            this.$emit('change', value);
        },
        updateModel() {
            this.currentValue = this.value === this.trueValue;
        }
    }
};
</script>

<style lang="less" scoped>
@themeColor: #00CECF;
.c-radio {
    display: inline-block;
    user-select: none;
    .c-checkbox--input {
        position: relative;
        vertical-align: middle;
        line-height: 1;
        .c-checkbox--inner {
            display: inline-block;
            position: relative;
            border: 1px solid #dcdfe6;
            border-radius: 2px;
            box-sizing: border-box;
            width: 12px;
            height: 12px;
            background-color: #fff;
            z-index: 1;
            transition: border-color .25s cubic-bezier(.71, -.46, .29, 1.46), background-color .25s cubic-bezier(.71, -.46, .29, 1.46);
            &::after {
                box-sizing: content-box;
                content: "";
                border: 1px solid #fff;
                border-left: 0;
                border-top: 0;
                width: 2px;
                height: 5px;
                left: 4px;
                position: absolute;
                top: 1px;
                transform: rotate(45deg) scaleY(0);
                transition: transform .15s ease-in .05s;
                transform-origin: center
            }
        }
        &.is-checked {
            .c-checkbox--inner {
                border-color: @themeColor;
                background-color: @themeColor;
                &::after {
                    transform:rotate(45deg) scaleY(1);
                }
            }
        }
    }
    .c-checkbox--original {
        position: absolute;
        outline: none;
        width: 0;
        height: 0;
        margin: 0;
        opacity: 0;
        z-index: -1;
    }
}
</style>